import axios from 'axios'
import {EntityDto} from '../../../../../../../services/dto/entityDto'
import CreateNewsAttachment from './dto/CreateNewsAttachment'
import GetAllNewsAttachments from './dto/GetAllNewsAttachments'
import UpdateNewsAttachment from './dto/UpdateNewsAttachment'
import GetNewsAttachment from './dto/GetNewsAttachment'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/NewsAttachment/Create`
export const URL_DELETE = `${API_URL}/NewsAttachment/Delete`
export const URL_GET = `${API_URL}/NewsAttachment/Get`
export const URL_GET_BY_NEWS_ID = `${API_URL}/NewsAttachment/GetByNewsId`
export const URL_UPDATE = `${API_URL}/NewsAttachment/Update`

export function onCreateNewsAttachment(
  createNewsAttachment: CreateNewsAttachment
): Promise<boolean> {
  return axios.post(URL_CREATE, createNewsAttachment)
}

export function onDeleteNewsAttachment(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetNewsAttachment(entityDto: EntityDto): Promise<GetNewsAttachment> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetNewsAttachmentByNewsId(news: EntityDto): Promise<GetAllNewsAttachments> {
  return axios.get(URL_GET_BY_NEWS_ID, {params: news})
}

export function onUpdateNewsAttachment(
  updateNewsAttachmentInput: UpdateNewsAttachment
): Promise<boolean> {
  return axios.put(URL_UPDATE, updateNewsAttachmentInput)
}
